import { LookupValues } from './types';

export const NODE_ENVIRONMENT = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production',
    TEST: 'test',
} as const;
export type NodeEnvironment = LookupValues<typeof NODE_ENVIRONMENT>;

export const DEPLOYMENT_ENVIRONMENT = {
    LOCAL: 'local',
    DEVELOPMENT: 'itrc_dev',
    STAGING: 'itrc_stage',
    PRODUCTION: 'itrc_prod',
} as const;
export type DeploymentEnvironment = LookupValues<typeof DEPLOYMENT_ENVIRONMENT>;
